<ng-container *ngFor="let button of GetActions(Azioni)">
    <button type="submit" type="button" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? ''"
            *ngIf="(button.nome != 'Elimina' || !HideDelete ) && campoUtility.ButtonShow(button,Item)"
            (click)='customButton(Item,button)'>
    <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
    <span [ngClass]="button['labelClass']"> {{ button['nome'] | translate }} </span>
    </button>
</ng-container>
